export default {
  videoLectures: {},

  recentVideoUploadInfo: null,
};



// WEBPACK FOOTER //
// ./src/app/video-lectures/store/state.js